import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Homepage from "../../components/Homepage/Homepage";
import ToastError from "../../components/Notification/ToastError";
import Search from "../../components/Track/Search";
import { converts, headers } from "../../libs";
import { ValTrack } from "../../validation/TrackValidation";

const initialTrack = {
  invoice: "",
  no_hp: 0,
  captcha: "",
};

function Home() {
  const history = useHistory();
  const covidRef = useRef(null);
  const [menu, setMenu] = useState(1); //1 All, 2 Service, 3 Media
  const [parameter, setParameter] = useState(1); //1 paket, 2 satuan
  const [layanan, setLayanan] = useState([]);
  const [satuan, setSatuan] = useState([]);
  const [media, setMedia] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadPage, setLoadPage] = useState(false);

  const [loadTrack, setLoadTrack] = useState(false);
  const [isTrack, setTrack] = useState(false);
  const [dataTrack, setDataTrack] = useState(initialTrack);
  const [captcha, setCaptcha] = useState("");

  const limit = 10;
  const [page, setPage] = useState("0");
  const [isMore, setMore] = useState(false);

  const [isError, setError] = useState([]);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket`,
        { offset: 0, limit },
        { headers: await headers({ offset: 0, limit }) }
      );

      const satuan = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
        { offset: 0, limit },
        {
          headers: await headers({
            offset: 0,
            limit,
          }),
        }
      );

      const product = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/katalog/product`,
        { offset: 0, limit },
        { headers: await headers({ offset: 0, limit }) }
      );

      if (
        Number(response.data.code) === 200 &&
        Number(product.data.code) === 200 &&
        Number(satuan.data.code) === 200
      ) {
        setLayanan(response.data.data);
        setMedia(product.data.data);
        setSatuan(satuan.data.data);

        if (response.data.data.length < 10) {
          setMore(false);
        } else setMore(true);

        if (product.data.data.length < 10) {
          setMore(false);
        } else setMore(true);

        setLoading(false);
      } else {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    } catch (e) {
      setOpen(true);
      setResponse("");
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const handleMenu = (value) => {
    // Ini menu produk
    // if (value === 2) {
    //   handleParameter(1);
    // }
    setMenu(value);
    setParameter(1);
    GetData();
    setPage("0");
    setMore(false);
    setFilter("");
  };

  const handleParameter = async (value, is_covid) => {
    setLoading(true);
    setPage("0");
    setFilter("");
    setMore(false);

    if (value === 1) {
      // Ini field paket
      setParameter(1);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket`,
          { offset: 0, limit },
          { headers: await headers({ offset: 0, limit }) }
        );

        if (Number(response.data.code) === 200) {
          setLayanan(response.data.data);

          if (response.data.data.length < 10) {
            setMore(false);
          } else setMore(true);

          setLoading(false);
        } else {
          setLayanan([]);

          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setLayanan([]);

        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    } else {
      // Ini field satuan
      setParameter(2);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
          { offset: 0, limit, is_covid: is_covid ? 1 : null },
          {
            headers: await headers({
              offset: 0,
              limit,
              is_covid: is_covid ? 1 : null,
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          setLayanan(response.data.data);

          if (response.data.data.length < 10) {
            setMore(false);
          } else setMore(true);

          setLoading(false);
        } else {
          setLayanan([]);

          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setLayanan([]);

        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    }
  };

  const handlePagination = async () => {
    setLoadPage(true);

    if (menu === 2 && parameter === 1) {
      // Ini adalah Paket (Parameter 1)
      try {
        const pages = 10 + Number(page);
        setPage(pages.toString());
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket`,
          { offset: pages.toString(), limit },
          {
            headers: await headers({
              offset: pages.toString(),
              limit,
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          let data = [...layanan];
          data.push(response.data.data);
          data = data.flat();
          data = data.filter(
            (v, i, a) => a.findIndex((t) => t.id === v.id) === i
          );

          if (response.data.data.length < 10) {
            setMore(false);
          } else setMore(true);

          setLayanan(data);
          setLoadPage(false);
        } else {
          setLayanan([]);
          setOpen(true);
          setResponse("");
          setLoadPage(false);
        }
      } catch (e) {
        setLayanan([]);
        setOpen(true);
        setResponse("");
        setLoadPage(false);
      }
    } else if (menu === 2 && parameter === 2) {
      // Ini adalah Satuan (Parameter 1)
      try {
        const pages = 10 + Number(page);
        setPage(pages.toString());

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
          { offset: pages.toString(), limit },
          {
            headers: await headers({
              offset: pages.toString(),
              limit,
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          let data = [...layanan];
          data.push(response.data.data);
          data = data.flat();
          data = data.filter(
            (v, i, a) => a.findIndex((t) => t.id === v.id) === i
          );

          if (response.data.data.length < 10) {
            setMore(false);
          } else setMore(true);

          setLayanan(data);
          setLoadPage(false);
        } else {
          setLayanan([]);

          setOpen(true);
          setResponse("");
          setLoadPage(false);
        }
      } catch (e) {
        setLayanan([]);

        setOpen(true);
        setResponse("");
        setLoadPage(false);
      }
    } else {
      // Ini adalah media
      try {
        const pages = 10 + Number(page);
        setPage(pages.toString());

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/katalog/product`,
          { offset: pages.toString(), limit },
          {
            headers: await headers({
              offset: pages.toString(),
              limit,
            }),
          }
        );

        if (Number(response.data.code) === 200) {
          let data = [...media];
          data.push(response.data.data);
          data = data.flat();
          data = data.filter(
            (v, i, a) => a.findIndex((t) => t.id === v.id) === i
          );

          if (response.data.data.length < 10) {
            setMore(false);
          } else setMore(true);

          setMedia(data);
          setLoadPage(false);
        } else {
          setMedia([]);

          setOpen(true);
          setResponse("");
          setLoadPage(false);
        }
      } catch (e) {
        setMedia([]);

        setOpen(true);
        setResponse("");
        setLoadPage(false);
      }
    }
  };

  const onFilter = async (e) => {
    const { value } = e.target;
    setFilter(value);

    if (e.key === "Enter") {
      if (menu === 2 && parameter === 1) {
        //menu layanan parameter true (paket)
        try {
          let response;
          filter.length > 0
            ? (response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket`,
                { offset: "0", limit, search: filter },
                {
                  headers: await headers({
                    offset: "0",
                    limit,
                    search: filter,
                  }),
                }
              ))
            : (response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/katalog/paket`,
                { offset: "0", limit },
                {
                  headers: await headers({
                    offset: "0",
                    limit,
                  }),
                }
              ));

          if (Number(response.data.code) === 200) {
            setLayanan(response.data.data);

            if (response.data.data.length < 10) {
              setMore(false);
            } else setMore(true);

            setLoading(false);
          } else {
            setLayanan([]);

            setOpen(true);
            setResponse("");
            setLoading(false);
          }
        } catch (e) {
          setLayanan([]);

          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } else if (menu === 2 && parameter === 2) {
        //menu layanan parameter false (satuan)
        try {
          let response;
          filter.length > 0
            ? (response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
                { offset: "0", limit, search: filter },
                {
                  headers: await headers({
                    offset: "0",
                    limit,
                    search: filter,
                  }),
                }
              ))
            : (response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
                { offset: "0", limit },
                {
                  headers: await headers({
                    offset: "0",
                    limit,
                  }),
                }
              ));

          if (Number(response.data.code) === 200) {
            setLayanan(response.data.data);
            if (response.data.data.length < 10) {
              setMore(false);
            } else setMore(true);
            setLoading(false);
          } else {
            setLayanan([]);

            setOpen(true);
            setResponse("");
            setLoading(false);
          }
        } catch (e) {
          setLayanan([]);

          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } else if (menu === 3) {
        //menu media
        try {
          let response;
          filter.length > 0
            ? (response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/katalog/product`,
                { offset: "0", limit, search: filter },
                {
                  headers: await headers({
                    offset: "0",
                    limit,
                    search: filter,
                  }),
                }
              ))
            : (response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/katalog/product`,
                { offset: "0", limit },
                {
                  headers: await headers({
                    offset: "0",
                    limit,
                  }),
                }
              ));

          if (Number(response.data.code) === 200) {
            setMedia(response.data.data);
            if (response.data.data.length < 10) {
              setMore(false);
            } else setMore(true);
            setLoading(false);
          } else {
            setMedia([]);

            setOpen(true);
            setResponse("");
            setLoading(false);
          }
        } catch (e) {
          setMedia([]);

          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      }
    }
  };

  const scrollCovid = () => {
    if (covidRef.current) {
      covidRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setMenu(2);
    handleParameter(2, true);
  };

  /** AREA TRACKING SECTION */

  const onModal = async () => {
    setTrack(true);
    onReset();
  };

  const onReset = () => {
    setDataTrack(initialTrack);
    setError([]);
    setLoadTrack(false);
  };

  const onSearch = async () => {
    setLoadTrack(true);
    const error = await ValTrack(dataTrack, captcha);

    if (error.length > 0) {
      setError(error);
      setLoadTrack(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/tracking`,
          { invoice: dataTrack.invoice, no_hp: dataTrack.no_hp.toString() },
          {
            headers: await headers({
              invoice: dataTrack.invoice,
              no_hp: dataTrack.no_hp.toString(),
            }),
          }
        );

        if (
          Number(response.data.code) === 200 &&
          response.data.message !== "Data tidak ditemukan"
        ) {
          setLoadTrack(false);
          setTrack(false);

          const convert = await converts({
            id: response.data.data.id,
            invoice: dataTrack.invoice,
            no_hp: dataTrack.no_hp.toString(),
          });

          history.push(`/lacak?token=${convert}`);
        } else {
          setOpen(true);
          setResponse(`Mohon maaf data tidak dapat ditemukan`);
          setLoadTrack(false);
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoadTrack(false);
      }
    }
  };

  const onCancel = () => {
    setTrack(false);
    onReset();
  };

  const onChangeTrack = (e) => {
    const { name, value } = e.target;
    if (name === "no_hp") {
      setDataTrack({ ...dataTrack, [name]: value.replace(/[^0-9]/g, "") });
    } else {
      setDataTrack({ ...dataTrack, [name]: value });
    }
    setError([]);
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <Search
        props={{
          isTrack,
          loadTrack,
          onCancel,
          onSearch,
          onChangeTrack,
          dataTrack,
          setCaptcha,
          isError,
        }}
      />
      <Homepage
        props={{
          menu,
          parameter,
          handleMenu,
          handleParameter,
          loading,
          loadPage,
          layanan,
          satuan,
          media,
          handlePagination,
          onModal,
          isMore,
          onFilter,
          filter,
          covidRef,
          scrollCovid,
        }}
      />
    </>
  );
}

export default Home;
